import { Switch as SwitchComponent } from '@mantine/core'

import styles from './switch.module.scss'

export const Switch = SwitchComponent.extend({
  defaultProps: {
    color: 'green.9',
    size: 'xs',
    withThumbIndicator: false,
  },
  classNames: styles,
})
